<template>
  <v-dialog
    max-width="560"
    data-testid="accountsBulk-modal-createdAccountsSummary"
    :value="show"
    @click:outside="$emit('close')"
  >
    <v-card>
      <v-card-title>
        {{ titleText }}
      </v-card-title>
      <v-card-text>
        <v-data-table
          data-private
          disable-sort
          disable-pagination
          hide-default-footer
          data-testid="addPeopleBulk-table-missedUsers"
          class="mt-4 table"
          :headers="headers"
          :items="missedAccounts"
        >
          <template v-slot:item.name="{ item }">
            <div class="d-flex align-center">
              <UserAvatar :account="item.account" size="28px" fontSize="10px" />
              <p class="ma-0 pa-0 ml-2">{{ item.account.displayname }}</p>
            </div>
          </template>
          <template v-slot:item.email="{ item }">
            <div class="d-flex align-center">
              <p class="ma-0 pa-0">{{ item.account.email }}</p>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions class="justify-end">
        <Button
          data-testid="addUsersBulk-button-missedAccountsClose"
          class="mb-2"
          color="primary"
          :text="$t('common.button.close')"
          @click="$emit('close')"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Button from '@/components/UI/Button'
import UserAvatar from '@/components/UserAvatar.vue'

export default {
  name: 'MissedAccountsModal',

  components: {
    Button,
    UserAvatar,
  },

  props: {
    missedAccounts: {
      type: Array,
      required: true,
      default: () => [],
    },
    show: Boolean,
  },

  data() {
    return {
      headers: [
        {
          text: this.$t('common.name'),
          value: 'name',
        },
        {
          text: this.$t('common.email_one'),
          value: 'email',
        },
      ],
    }
  },

  computed: {
    titleText() {
      return this.$t('common.users.add_bulk_modal_title', {
        missed: this.missed,
      })
    },

    missed() {
      return this.missedAccounts.length ?? 0
    },
  },
}
</script>
<style lang="scss" scoped>
.table {
  border: 1px solid $color-blue-grey-lighten2;
}
</style>
